import { useMemo } from 'react'

import _ from 'lodash'
import { useFormContext, useWatch } from 'react-hook-form'

import { useLevelPlaySurface } from '@/shared/level-play'
import { Select } from '@/shared/ui/Form'

import { AnswerOption } from './AnswerOption'



export const LevelPlayQuestionMultipleChoice = ({ meta }) => {
  const { answerIsRight, answerIsWrong, disableInputs } = useLevelPlaySurface()
  const { setValue } = useFormContext()
  const watchAnswer = useWatch({ name: 'answer' })
  const alternatives = useMemo(() => {
    let alternatives = _.get(meta, 'alternatives', [])
    alternatives = meta?.shuffle ? _.shuffle(alternatives) : alternatives
    alternatives = _.uniqBy(alternatives, 'name')

    return alternatives
  }, [meta?.shuffle, meta?.alternatives])
  const showSelect = alternatives.length > 8
  const correctLength = alternatives.filter(
    alt => alt.is_correct == true
  ).length
  const isMultiple = correctLength >= 2

  const onSelect = name => {
    if (isMultiple) {
      const newAnswer = watchAnswer?.includes(name)
        ? [...watchAnswer.filter(opt => opt !== name)]
        : [...(watchAnswer || []), name]

      setValue('answer', newAnswer)
    } else {
      setValue('answer', name)
    }
  }
  const checkIsSelected = name => {
    if (isMultiple) {
      return watchAnswer?.includes(name)
    }

    return watchAnswer == name
  }

  if (showSelect)
    return (
      <Select
        name="answer"
        options={alternatives.map(opt => ({
          label: `${opt.name}`,
          value: opt.name
        }))}
        size="lg"
        required
        disabled={disableInputs}
        multiple={correctLength >= 2}
      />
    )
  return (
    <div className="flex flex-col gap-4">
      {alternatives.map((opt, index) => {
        const isSelected = checkIsSelected(opt.name)
        let state = 'default'
        if (answerIsRight && isSelected) {
          state = 'correct'
        } else if (answerIsWrong && isSelected) {
          state = 'incorrect'
        } else if (isSelected) {
          state = 'selected'
        }

        return (
          <AnswerOption
            key={`opt-${index}`}
            state={state}
            onClick={() => onSelect(opt.name)}
            disabled={disableInputs}
          >
            {opt.name}
          </AnswerOption>
        )
      })}
    </div>
  )
}
